/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.textarea_counter = {

  current_id: 0,

  init() {
    if ($(".js-textarea-counter").length) {
      return App.textarea_counter.create_counters();
    }
  },


  create_counters() {
    // App.log('in create_counters');
    $(".js-textarea-counter:not(.js-textarea-counterized)").each(function() {
      const id = ++App.textarea_counter.current_id;
      const $this = $(this);
      const content = $this.val();

      const max_ascii = $this.attr("data-maxlength-ascii")*1;
      const max_non_ascii = $this.attr("data-maxlength-non-ascii")*1;
      const max = App.utils.is_ascii(content) ? max_ascii : max_non_ascii;

      const remaining = max - content.length;
      $this.attr("data-counter-id", id);

      const $counter = $("<span>", { class: "textarea-counter", "data-counter-id": id })
                         .text(`${max - remaining} / ${max}`);

      if ($this.data("counter-position") === "bottom") {
        $counter.addClass("textarea-counter--bottom");
        $this.after($counter);
      } else {
        $this.before($counter);
      }

      return $this.addClass("js-textarea-counterized");
    });

    $(document)
      .off("keyup keypress change", "textarea.js-textarea-counter", App.textarea_counter.changed)
      .on("keyup keypress change", "textarea.js-textarea-counter", App.textarea_counter.changed);

    return $(".js-textarea-counterized").change();
  },


  changed(evt) {
    const $this = $(evt.target);
    const content = $this.val();

    const is_ascii = App.utils.is_ascii(content);
    const max_ascii = $this.attr("data-maxlength-ascii")*1;
    const max_non_ascii = $this.attr("data-maxlength-non-ascii")*1;
    const coupon_url_length = ($this.attr("data-coupon-url-length")*1) || 0;
    const has_coupon = $this.attr("data-coupon-url");
    let max = is_ascii ? max_ascii : max_non_ascii;
    const max_for_counter = max;

    let length = App.message_modal_counter.get_length(this);
    // add 2 to coupon urls for the prepended newline
    if (has_coupon) { length += 2; }
    const remaining = max - length;

    if (is_ascii) {
      $(".js-special-chars-notice").addClass("hidden");
    } else {
      $(".js-special-chars-notice").removeClass("hidden");
    }

    if (remaining < 0) {
      if (has_coupon) { max -= coupon_url_length; }
      $this.val($this.val().substring(0, max));
    }


    const _this = this;
    window.setTimeout(function() {
      const id = $this.data("counter-id");
      const $counter = $(`.textarea-counter[data-counter-id=${id}]`);
      const new_length = App.message_modal_counter.get_length(_this);
      return $counter.text(`${new_length} / ${max_for_counter}`);
    });

    // The LinkifyingEditor has its change listener added before ours,
    // so we have to force it to render again since the value could
    // have been cut off at the max.
    return $this.trigger("counter:changed");
  }
};


App.ready(App.textarea_counter.init);
App.modal_ready(App.textarea_counter.init);
